import React from 'react';
import { render } from 'react-dom';

import Switch from './switch';

import '../globalStyled';

render(
  <Switch />
, document.getElementById('root'))



// WEBPACK FOOTER //
// ./client/Admin/index.js